import EkomApi from '../api/EkomApi'
import { FETCH_INTERVAL_KEY, useFetchInterval } from './useFetchInterval'

export const useCountUnreadOutgoing = () => {
  return useFetchInterval<number>(EkomApi.getCountUnreadOutgoing, FETCH_INTERVAL_KEY.OUT)
}
